import { createAsyncThunk } from '@reduxjs/toolkit';
import { audioExtensions, convertableTypesFiles, imageExtensions, videoExtensions } from 'helpers/filesExtensions';
import { requestPDFFile, getTableFile, getPathToImage, getPathToVideo } from 'helpers/getPathToDocument';
import { IDocumentInfo, ILocale} from 'interfaces';


const fetchDocumentToViewer = createAsyncThunk(
  'viewer/getDocument',  
  async (payload: IDocumentInfo & ILocale, thunkApi) => {    
    try {
      let file: any;
      const fileExtension = payload?.extension?.toLocaleLowerCase();
      
      if (fileExtension  === 'xlsx') {
        file = await getTableFile(payload);
      } else if (imageExtensions.includes(fileExtension!)) {
        file = await getPathToImage(payload);
      } else if (videoExtensions.includes(fileExtension!) || audioExtensions.includes(fileExtension!)) {
        file = await getPathToVideo(payload);
      } else if ([...convertableTypesFiles, 'pdf'].includes(fileExtension!)) {
        file = await requestPDFFile({ ...payload, locale: payload.locale });
      } else {
        return {filename: payload.name, extension: fileExtension, document: payload, fileURL: 'extension not supported'};
      }
      return {...file, extension: fileExtension, document: payload};
    } catch (err: any) {
      if (err?.response?.data?.message === 'TEMPLINK_IS_EXPIRED') {
        return thunkApi.rejectWithValue('TEMPLINK_IS_EXPIRED');
      } else if (err?.response?.status === 500) {
        return thunkApi.rejectWithValue('SERVER_ERROR');
      } else if (err?.response?.status === 403) {
        return thunkApi.rejectWithValue('WRONG_PASSWORD');
      } else {
        return thunkApi.rejectWithValue('Не удалось получить документ');
      }
    }
  }
);

export default fetchDocumentToViewer;
